import {
  Button,
  Container,
  Paragraph,
  Strong,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";

const textCnt = css`
  width: 100%;
`;
const titleStyle = css`
  color: white;
  font-size: 1.5vh;
`;
const messageStyle = css`
  font-size: 1.5vh;
  align-self: flex-end;
  color: white;
`;
const bttnStyle = css`
  align-self: center;
  font-size: 1.5vh;
  font-weight: 600;
  width: 2vh;
  height: 2vh;
  color: white;
`;

export const Toast = ({
  type,
  title = "Unkown error",
  message = "please try again later.",
  hideToast,
  hidden,
  position,
  top,
  width,
  height,
}) => {
  const toastCnt = css`
    background-color: ${({ theme }) =>
      type === "Success"
        ? "green"
        : type === "Error"
        ? "red"
        : type === "Warning"
        ? "orange"
        : theme.bgColor};
    display: ${hidden ? "none" : "flex"};
    width: ${width || "100%"};
    height: ${height};
    top: ${top};
    position: ${position};
    border-radius: 12px;
    padding: 0 1vw;
    justify-content: space-between;
    align-items: center;
  `;

  return (
    <Container $baseStyle={toastCnt}>
      <Container $baseStyle={textCnt}>
        <Strong $baseStyle={titleStyle}>{title}:&nbsp;</Strong>
        <Paragraph $baseStyle={messageStyle}>{message}</Paragraph>
      </Container>
      <Button $baseStyle={bttnStyle} type="button" onClick={() => hideToast()}>
        x
      </Button>
    </Container>
  );
};
